import React from "react";

function TextInput({ labelText, type }) {
	return (
		<div className="relative">
			<input
				className="absolute top-0 left-0 w-full h-full outline-none bg-transparent focus:outline-none border-2 border-slate-300 dark:border-darkborder focus:border-sky-500 focus:dark:border-sky-500 rounded py-[1.1rem] px-3 peer"
				type={type}
				id={labelText}
				autoComplete="off"
				placeholder=""
			/>
			<label
				className={
					type === "date"
						? "absolute left-[.7rem] -top-2.5 px-1 cursor-text bg-slate-50 dark:bg-darkbg dark:text-darktext transition-all duration-200 ease-in text-xs peer-focus:text-sky-500"
						: "absolute left-3 top-1.5 px-1 cursor-text bg-slate-50 dark:bg-darkbg dark:text-darktext transition-all duration-200 ease-in peer-focus:-top-2.5 peer-focus:text-xs peer-focus:left-[.7rem] peer-focus:text-sky-500"
				}
				htmlFor={labelText}>
				{labelText}
			</label>
		</div>
	);
}

export default TextInput;
